import { render, staticRenderFns } from "./wyModalEditGoal.vue?vue&type=template&id=180a8e35&"
import script from "./wyModalEditGoal.vue?vue&type=script&lang=js&"
export * from "./wyModalEditGoal.vue?vue&type=script&lang=js&"
import style0 from "./wyModalEditGoal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports